import React from 'react';
import withMedia from '~/modules/core/utils/mediaHelpers/withMedia';
import ProductDetailsDesktopLayout from './ProductDetailsDesktopLayout';
import ProductDetailsXSmallLayout from './ProductDetailsXSmallLayout';
import ProductDetailsMediumLayout from './ProductDetailsMediumLayout';

export default withMedia(
  props => (props.media.minDesktop ? ( // eslint-disable-line no-nested-ternary
    <ProductDetailsDesktopLayout {...props}>{props.children}</ProductDetailsDesktopLayout>
  ) : props.media.xsmall ? (
    <ProductDetailsXSmallLayout {...props}>{props.children}</ProductDetailsXSmallLayout>
  ) : (
    <ProductDetailsMediumLayout {...props}>{props.children}</ProductDetailsMediumLayout>
  )),
);
